const config = require('./config');

// 先不考虑广告碎片
const chipType = {
    getStructuredFragment: 'struct',
    getStaticFragment: 'static',
    getRecommendFragment: 'recommend',
};

// 先不考虑v4
const { allData = {} } = config;
const { transferV3 = [] } = allData;

const chipList = transferV3.map(data => {
    const [name = '', info = ''] = data[0].split(':');
    const [title, groupName = title] = info.split('_');
    const type = chipType[data[2]];
    const id = data[3];

    return [name, { id, name, type, title, groupName }];
});

const ChipMap = Object.fromEntries(chipList);

module.exports = { ChipMap };
